import { useEffect } from 'react';
import { useSelector, useStore } from 'react-redux';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { writeToMemento } from '@/redux/draft/memento/writeToMemento';
import { StoreState } from '@/redux/types';

export function useSaveMemento() {
  const store = useStore<StoreState>();
  const draft = useSelector(getDraft);

  // don't compare the whole draft, but only the 5 properties used in sharingDraftMapper/createDraftModel.ts
  const { productType, appearance, view, configurationIds, configurations } = draft;
  useEffect(() => {
    writeToMemento(store.getState());
  }, [store, productType, appearance, view, configurationIds, configurations]);
}
